import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import "./ExecutionAndDocumentationMobileView.css";
import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";
import JSZip from "jszip";
import axios from "axios";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

function ExecutionAndDocumentationMobileStep2({
  getDocument,
  documentResponse,
}) {
  const location = useLocation();
  const fileInputRef = useRef(null);
  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const searchParams = new URLSearchParams(location.search);
  const encryptedRelocationID = searchParams.get("ID");
  const Relocation_ID = decryptRelocationID(encryptedRelocationID);

  const [isUploaded, setIsUploaded] = useState(false);
  const [uploadedDocumentTypeId, setUploadedDocumentTypeId] = useState(null);

  const [individualDocResponse, setIndividualDocResponse] = useState(null);
  const [individualDocResponse2, setIndividualDocResponse2] = useState(null);
  const [individualDocResponse3, setIndividualDocResponse3] = useState(null);
  const [individualDocResponse4, setIndividualDocResponse4] = useState(null);

  const [dateValue1, setDateValue1] = useState("");
  const [dateValue2, setDateValue2] = useState("");
  const [dateValue3, setDateValue3] = useState("");
  const [dateValue4, setDateValue4] = useState("");

  let updateData = documentResponse;

  const [firstItem, setFirstItem] = useState({
    relocation_id: Relocation_ID,
    doc_ID: "",
    documentTypeId: "",
    manual_createdDate: "",
    form_type: "",
    document: "",
    doc_name: "",
    is_Active: "",
    is_submit: "",
    user_type: 3,
  });

  useEffect(() => {
    getIndividualDoc(10);
    getIndividualDoc(34);
    getIndividualDoc(32);
    getIndividualDoc(4);

    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (updateData) {
      const individualDocResponse = updateData.filter(
        (doc) => doc.document_type_id === 10
      );
      const individualDocResponse2 = updateData.filter(
        (doc) => doc.document_type_id === 34
      );
      const individualDocResponse3 = updateData.filter(
        (doc) => doc.document_type_id === 32
      );
      const individualDocResponse4 = updateData.filter(
        (doc) => doc.document_type_id === 4
      );

      setIndividualDocResponse(individualDocResponse);
      setIndividualDocResponse2(individualDocResponse2);
      setIndividualDocResponse3(individualDocResponse3);
      setIndividualDocResponse4(individualDocResponse4);
    }
  }, [updateData]);

  function getIndividualDoc(documentTypeId) {
    const storedToken = JSON.parse(localStorage.getItem("accessToken"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}customerget/GetCustomerDocumentsDetail?relocation_id=` +
            Relocation_ID +
            `&option=1&is_submit=0&documentTypeId=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          let data = response.data.data;

          // Divide the array based on documentTypeId
          const individualDocResponse = data.filter(
            (doc) => doc.document_type_id === 10
          );
          const individualDocResponse2 = data.filter(
            (doc) => doc.document_type_id === 34
          );
          const individualDocResponse3 = data.filter(
            (doc) => doc.document_type_id === 32
          );
          const individualDocResponse4 = data.filter(
            (doc) => doc.document_type_id === 4
          );

          setIndividualDocResponse(individualDocResponse);
          setIndividualDocResponse2(individualDocResponse2);
          setIndividualDocResponse3(individualDocResponse3);
          setIndividualDocResponse4(individualDocResponse4);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);

      return null;
    }
  }

  function handleChangeDoc(e) {
    const { name, value, files } = e.target;

    if (name === "doc_name") {
      const file = files[0];
      if (file.size > 50 * 1024 * 1024) {
        alert("File size exceeds 50 MB limit.");
        e.target.value = null;
        return;
      }

      if (isValidFileType(file)) {
        if (
          file.type === "application/zip" ||
          file.type === "application/x-zip-compressed"
        ) {
          validateZipFile(file, name, e);
        } else {
          getUpdatedImage(file, name);
        }
      } else {
        alert("Unsupported file type. Please upload a valid file.");
        // Reset the file input field
        e.target.value = null;
        return;
      }
    } else {
      setFirstItem({
        ...firstItem,
        [name]: value,
      });
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "dateValue1") {
      setDateValue1(value);
    } else if (name === "dateValue2") {
      setDateValue2(value);
    } else if (name === "dateValue3") {
      setDateValue3(value);
    } else if (name === "dateValue4") {
      setDateValue4(value);
    }
  };

  function getUpdatedImage(file, name) {
    if (file) {
      setFirstItem({
        ...firstItem,
        [name]: file, // Store the file object directly
      });
    }
  }

  function isValidFileType(file) {
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
      "application/vnd.ms-excel", // XLS
      "video/mp4",
      "video/x-msvideo", // AVI
      "video/x-matroska", // MKV
      "video/quicktime", // MOV
      "application/zip", // ZIP
      "application/x-zip-compressed", // Alternate ZIP MIME type
    ];
    return file && allowedTypes.includes(file.type);
  }

  function validateZipFile(file, name, e) {
    const reader = new FileReader();
    reader.onload = function (event) {
      const zipData = event.target.result;

      try {
        const jszip = new JSZip();
        jszip.loadAsync(zipData).then((zip) => {
          const allowedExtensions = ["jpg", "png", "pdf", "docx", "xlsx"];
          let isValid = true;

          zip.forEach((relativePath, zipEntry) => {
            const extension = relativePath.split(".").pop().toLowerCase();
            if (!allowedExtensions.includes(extension)) {
              isValid = false;
            }
          });

          if (isValid) {
            getUpdatedImage(file, name);
          } else {
            alert("ZIP file contains unsupported file types.");
            e.target.value = null;
          }
        });
      } catch (error) {
        alert("Error reading ZIP file.");
        e.target.value = null;
      }
    };
    reader.readAsArrayBuffer(file);
  }

  const uploadVaccinationBook = async (documentTypeId) => {
    if (
      (documentTypeId === 4 && !firstItem.doc_name) ||
      (documentTypeId === 32 && !firstItem.doc_name)
    ) {
      alert("Please select a file before uploading.");
      return; // Exit the function early if no file is selected
    }

    const formData = new FormData();

    if (documentTypeId === 10) {
      firstItem.manual_createdDate = dateValue1;
    }

    if (documentTypeId === 34) {
      firstItem.manual_createdDate = dateValue2;
    }

    if (documentTypeId === 32) {
      firstItem.manual_createdDate = dateValue3;
    }

    if (documentTypeId === 4) {
      firstItem.manual_createdDate = dateValue4;
    }

    // Append form fields and the file to FormData
    formData.append("relocation_id", Relocation_ID);
    formData.append("documentTypeId", documentTypeId);
    formData.append("manual_createdDate", firstItem.manual_createdDate);
    formData.append("doc_name", firstItem.doc_name);
    formData.append("user_type", 3);
    formData.append("form_type", firstItem.form_type);

    try {
      const storedToken = JSON.parse(localStorage.getItem("accessToken"));
      const response = await axios.post(
        `${baseAPI}customerpost/UpdateCustomerDocumentsDetail`,
        formData, // Send request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        setIsUploaded(true); // Set upload status to true on success
      }

      setUploadedDocumentTypeId(documentTypeId);
      getIndividualDoc(documentTypeId);

      setFirstItem({
        relocation_id: Relocation_ID,
        doc_ID: "",
        documentTypeId: "",
        manual_createdDate: "",
        form_type: "",
        document: "",
        doc_name: "",
        is_Active: "",
        is_submit: "",
        user_type: 3,
      });

      setDateValue1("");
      setDateValue2("");
      setDateValue3("");
      setDateValue4("");

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const formatDate = (dateString) => {
    const options = {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };

    const formattedDate = new Date(dateString).toLocaleString("en-US", options);
    return formattedDate;
  };

  async function deleteDoc(doc_ID) {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this document?"
    );

    if (isConfirmed) {
      const storedToken = JSON.parse(localStorage.getItem("accessToken"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}customerpost/UpdateCustomerDocsDelete`,
        {
          doc_ID: doc_ID, // Request body
        },
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      setIndividualDocResponse((prevDocs) =>
        prevDocs.filter((doc) => doc.doc_ID !== doc_ID)
      );

      setIndividualDocResponse2((prevDocs) =>
        prevDocs.filter((doc) => doc.doc_ID !== doc_ID)
      );
      setIndividualDocResponse3((prevDocs) =>
        prevDocs.filter((doc) => doc.doc_ID !== doc_ID)
      );

      setIndividualDocResponse4((prevDocs) =>
        prevDocs.filter((doc) => doc.doc_ID !== doc_ID)
      );
    }
  }

  async function submitDocument(doc_ID) {
    try {
      const storedToken = JSON.parse(localStorage.getItem("accessToken"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}customerpost/UpdateCustomerDocsSubmit`,
        { doc_ID: doc_ID },
        {
          // Send request body
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      getDocument();
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  }

  const [selectedForm, setSelectedForm] = useState("");

  const handleDivClick = (formType) => {
    setSelectedForm(formType); // Update selected form
    setFirstItem((prev) => ({ ...prev, form_type: formType })); // Update your state
  };

  const getDivStyle = (formType) => {
    return selectedForm === formType
      ? {
          border: "2px solid #5B489D",
          backgroundColor: "#E8E8FF",
          borderRadius: "8px",
          height: "40px",
        }
      : {
          border: "1px solid #5B489D",
          backgroundColor: "transparent",
          borderRadius: "8px",
          height: "40px",
        };
  };

  return (
    <div>
      <>
        <div
          className="py-4 px-2 mt-4"
          style={{ backgroundColor: "rgb(250, 250, 250)", borderRadius: "8px" }}
        >
          <h4 style={{ fontSize: "14px" }}>
            1. Administer Rabies Vaccine to the pet(Post Microchip)
          </h4>
          <h6
            className="px-3 py-0"
            style={{ fontSize: "12.5px", color: "#A0A0A0" }}
          >
            The first step for a titre test is to give the pet a rabies vaccine.
          It is mandatory to insert a microchip before giving the rabies vaccine
          to the pet.
            <span style={{ color: "#0096EB" }}>More Info</span>
          </h6>
          <h4
            className="px-3 py-0"
            style={{ fontSize: "12.5px", marginTop: "23px" }}
          >
            Date of rabies vaccination
          </h4>
          <div className="row px-3">
            <form className="form-row col-12 p-0">
              <input
                style={{
                  border: "1px solid #BEBEBE",
                  borderTopLeftRadius: "8px",
                  borderBottomLeftRadius: "8px",
                  fontSize: "14px",
                  height: "38px",
                }}
                type="date"
                placeholder="Enter"
                className="form-input"
                name="dateValue1"
              value={dateValue1}
              onChange={handleChange}
              />
              <button
                style={{
                  border: "1px solid #5B489D",
                  height: "36px",
                  fontSize: "14px",
                  backgroundColor: "#F8F9FACC",
                  color: "#6a6a6a",
                  with: "114px",
                  padding: "4px 27px 4px 27px",
                  borderTopRightRadius: "8px",
                  borderBottomRightRadius: "8px",
                }}
                type="submit"
                className="form-button update-btn-new"
                onClick={(e) => {
                e.preventDefault(); // Explicitly prevent default form submission
                uploadVaccinationBook(10); // Call the function with your desired parameter
              }}
              >
                Update
              </button>
            </form>
            {individualDocResponse?.length > 0 ? (
          <>
            <div className="px-3">
              <hr />
            </div>
            {individualDocResponse.map((item, index) => (
              <div
                className="container-fluid mt-1 d-flex justify-content-between align-items-center py-2"
                style={{
                  borderRadius: "7px",
                  boxShadow:
                    "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                  backgroundColor: "white",
                }}
                key={item.doc_ID}
              >
                <div className="order-main-list d-flex flex-column align-items-start px-2">
                  <h4 style={{ fontSize: "17px", color: "#6A6A6A" }}>
                  Rabies Vaccine
                  </h4>
                  <h5 style={{ fontSize: "11px", color: "#6A6A6A" }}>
                    {formatDate(item.manual_createdDate)}
                  </h5>
                </div>
                <div style={{display: "flex",flexDirection: "column",alignItems: "flex-end"}}>   

                  {item.is_submit === 2 ? (
                    <button
                      style={{
                        color: "#28A745",
                        fontWeight: "bold",
                        textDecoration: "none",
                        border: "none",
                        backgroundColor: "white",
                        display: "flex",
                      }}
                      onClick={() => submitDocument(item.doc_ID)}
                    >
                      Submit
                      <FontAwesomeIcon
                        icon={faArrowRightFromBracket}
                        style={{
                          padding: "5px 4px 0px 11px",
                          color: "#28A745",
                        }}
                      />
                    </button>
                  ) : (
                    <button
                      style={{
                        color: "#28A745",
                        width: "88%",
                        marginTop: "9.5px",
                        fontWeight: "bold",
                        cursor: "default",
                        textDecoration: "none",
                        border: "none",
                        backgroundColor: "white",
                      }}
                    >
                      Submitted
                    </button>
                  )}

                  {item.is_submit === 2 ? (
                    <button
                      onClick={() => deleteDoc(item.doc_ID)}
                      style={{
                        display: "flex",
                        color: "#FF0004",
                        borderStyle: "none",
                        background: "none",
                      }}
                    >
                      Delete{" "}
                      <DeleteOutlinedIcon
                        className="icon"
                        style={{ padding: "0 0 0 4px" }}
                      />
                    </button>
                  ) : null}
                </div>
              </div>
            ))}
          </>
        ) : null}
          </div>
        </div>
        <div
          className="py-4 px-2 mt-4"
          style={{ backgroundColor: "rgb(250, 250, 250)", borderRadius: "8px" }}
        >
          <h4 style={{ fontSize: "14px" }}>
            2. Blood Sample Collection.
          </h4>
          <h6
            className="px-3 py-0"
            style={{ fontSize: "12.5px", color: "#A0A0A0" }}
          >
            After the day of rabies vaccination, we will wait for 30 days. On the
          31st day, we will collect a blood sample from the pet. A 90-day
          cool-off period starts during which the pet cannot travel.
            <span style={{ color: "#0096EB" }}>More Info</span>
          </h6>
          <h4
            className="px-3 py-0"
            style={{ fontSize: "12.5px", marginTop: "23px" }}
          >
           Date of blood sample collection.
          </h4>
          <div className="row px-3">
            <form className="form-row col-12 p-0">
              <input
                style={{
                  border: "1px solid #BEBEBE",
                  borderTopLeftRadius: "8px",
                  borderBottomLeftRadius: "8px",
                  fontSize: "14px",
                  height: "38px",
                }}
                type="date"
                placeholder="Enter"
                className="form-input"
                name="dateValue2"
              value={dateValue2}
              onChange={handleChange}
              />
              <button
                style={{
                  border: "1px solid #5B489D",
                  height: "36px",
                  fontSize: "14px",
                  backgroundColor: "#F8F9FACC",
                  color: "#6a6a6a",
                  with: "114px",
                  padding: "4px 27px 4px 27px",
                  borderTopRightRadius: "8px",
                  borderBottomRightRadius: "8px",
                }}
                type="submit"
                className="form-button update-btn-new"
                onClick={(e) => {
                e.preventDefault(); // Explicitly prevent default form submission
                uploadVaccinationBook(34); // Call the function with your desired parameter
              }}
              >
                Update
              </button>
            </form>
            {individualDocResponse2?.length > 0 ? (
          <>
            <div className="px-3">
              <hr />
            </div>
            {individualDocResponse2.map((item, index) => (
              <div
                className="container-fluid mt-1 d-flex justify-content-between align-items-center py-2"
                style={{
                  borderRadius: "7px",
                  boxShadow:
                    "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                  backgroundColor: "white",
                }}
                key={item.doc_ID}
              >
                <div className="order-main-list d-flex flex-column align-items-start px-2">
                  <h4 style={{ fontSize: "17px", color: "#6A6A6A" }}>
                  Blood Sample Collection
                  </h4>
                  <h5 style={{ fontSize: "11px", color: "#6A6A6A" }}>
                    {formatDate(item.manual_createdDate)}
                  </h5>
                </div>
                <div style={{display: "flex",flexDirection: "column",alignItems: "flex-end"}}>                 

                  {item.is_submit === 2 ? (
                    <button
                      style={{
                        color: "#28A745",
                        fontWeight: "bold",
                        textDecoration: "none",
                        border: "none",
                        backgroundColor: "white",
                        display: "flex",
                      }}
                      onClick={() => submitDocument(item.doc_ID)}
                    >
                      Submit
                      <FontAwesomeIcon
                        icon={faArrowRightFromBracket}
                        style={{
                          padding: "5px 4px 0px 11px",
                          color: "#28A745",
                        }}
                      />
                    </button>
                  ) : (
                    <button
                      style={{
                        color: "#28A745",
                        width: "88%",
                        marginTop: "9.5px",
                        fontWeight: "bold",
                        cursor: "default",
                        textDecoration: "none",
                        border: "none",
                        backgroundColor: "white",
                      }}
                    >
                      Submitted
                    </button>
                  )}

                  {item.is_submit === 2 ? (
                    <button
                      onClick={() => deleteDoc(item.doc_ID)}
                      style={{
                        display: "flex",
                        color: "#FF0004",
                        borderStyle: "none",
                        background: "none",
                      }}
                    >
                      Delete{" "}
                      <DeleteOutlinedIcon
                        className="icon"
                        style={{ padding: "0 0 0 4px" }}
                      />
                    </button>
                  ) : null}
                </div>
              </div>
            ))}
          </>
        ) : null}
          </div>
        </div>
        <div
          className="py-4 px-2 mt-4"
          style={{ backgroundColor: "rgb(250, 250, 250)", borderRadius: "8px" }}
        >
          <h4 style={{ fontSize: "14px" }}>
          3. Rabies Serology Form.
          </h4>
          <h6
            className="px-3 py-0"
            style={{ fontSize: "12.5px", color: "#A0A0A0" }}
          >
            We need to submit a Rabies Serology form along with the blood sample
          to the laboratory. The choice of laboratory should be based on the
          destination. 
            <span style={{ color: "#0096EB" }}>More Info</span>
          </h6>
          {/* <h4
            className="px-3 py-0"
            style={{ fontSize: "12.5px", marginTop: "23px" }}
          >
            Date of rabies vaccination
          </h4> */}
          <h4
            className="px-3 mt-4"
            style={{ fontSize: "14px", color: "#6a6a6a", fontWeight: "bold" }}
          >
            Please select a form:
          </h4>
          <div className="row px-3 mb-4 d-flex justify-content-between">
            <div
              className="col-12  d-flex justify-content-between align-items-center"
              // style={{
              //   border: "1px solid #5B489D",
              //   borderRadius: "8px",
              //   height: "40px",
              // }}
              style={getDivStyle("KVAFSU Laboratory")}
            onClick={() => handleDivClick("KVAFSU Laboratory")}
            >
              <h5
                style={{
                  fontSize: "11px",
                  color: "#6a6a6a",
                  padding: "0px",
                  margin: "0px",
                }}
              >
                KVAFSU Laboratory
              </h5>
              <FontAwesomeIcon
                style={{ color: "#6a6a6a" }}
                icon={faPenToSquare}
              />
            </div>
          </div>
          <div className="row px-3 mb-4 d-flex justify-content-between">
            <div
              className="col-12  d-flex justify-content-between align-items-center"
              // style={{
              //   border: "1px solid #5B489D",
              //   borderRadius: "8px",
              //   height: "40px",
              // }}
              style={getDivStyle("Biobest Laboratory")}
            onClick={() => handleDivClick("Biobest Laboratory")}
            >
              <h5
                style={{
                  fontSize: "11px",
                  color: "#6a6a6a",
                  padding: "0px",
                  margin: "0px",
                }}
              >
                Biobest Laboratory
              </h5>
              <FontAwesomeIcon
                style={{ color: "#6a6a6a" }}
                icon={faPenToSquare}
              />
            </div>
          </div>
          <div className="row px-3 mb-4 d-flex justify-content-between">
            <div
              className="col-12  d-flex justify-content-between align-items-center"
              // style={{
              //   border: "1px solid #5B489D",
              //   borderRadius: "8px",
              //   height: "40px",
              // }}
              style={getDivStyle("APHA Laboratory")}
            onClick={() => handleDivClick("APHA Laboratory")}
            >
              <h5
                style={{
                  fontSize: "11px",
                  color: "#6a6a6a",
                  padding: "0px",
                  margin: "0px",
                }}
              >
                APHA Laboratory
              </h5>
              <FontAwesomeIcon
                style={{ color: "#6a6a6a" }}
                icon={faPenToSquare}
              />
            </div>
          </div>
          <h4
            className="px-3 mt-4"
            style={{ fontSize: "14px", color: "#6a6a6a", fontWeight: "bold" }}
          >
            Date of form submission
          </h4>
          <div className="row px-3">
            <form className="form-row col-12 p-0">
              <input
                style={{
                  border: "1px solid #BEBEBE",
                  borderTopLeftRadius: "8px",
                  borderBottomLeftRadius: "8px",
                  fontSize: "14px",
                  height: "38px",
                }}
                type="date"
                placeholder="Enter"
                className="form-input"
                name="dateValue3"
                  value={dateValue3}
                  onChange={handleChange}
              />
              <button
                style={{
                  border: "1px solid #5B489D",
                  height: "36px",
                  fontSize: "14px",
                  backgroundColor: "#F8F9FACC",
                  color: "#6a6a6a",
                  with: "114px",
                  padding: "4px 27px 4px 27px",
                  borderTopRightRadius: "8px",
                  borderBottomRightRadius: "8px",
                }}
                type="submit"
                className="form-button update-btn-new"
              >
                Update
              </button>
            </form>
            <form className="form-row col-12 px-0 py-3 execution-step-2-form">
              <input
                style={{
                  border: "1px solid #BEBEBE",
                  borderTopLeftRadius: "8px",
                  borderBottomLeftRadius: "8px",
                  fontSize: "14px",
                  height: "38px",
                }}
                type="file"
                placeholder="Enter"
                className="form-input"
                name="doc_name"
                  onChange={handleChangeDoc}
                  ref={fileInputRef}
                  required
              />
              <button
                style={{
                  border: "1px solid #5B489D",
                  height: "36px",
                  fontSize: "14px",
                  backgroundColor: "#F8F9FACC",
                  color: "#6a6a6a",
                  with: "114px",
                  padding: "4px 27px 4px 27px",
                  borderTopRightRadius: "8px",
                  borderBottomRightRadius: "8px",
                }}
                className="form-button update-btn-new"
                onClick={(e) => {
                    e.preventDefault(); // Explicitly prevent default form submission
                    uploadVaccinationBook(32); // Call the function with your desired parameter
                  }}
              >
                Upload
              </button>
            </form>
            {individualDocResponse3?.length > 0 ? (
          <>
            <div className="px-3">
              <hr />
            </div>
            {individualDocResponse3.map((item, index) => (
              <div
                className="container-fluid mt-1 d-flex justify-content-between align-items-center py-2"
                style={{
                  borderRadius: "7px",
                  boxShadow:
                    "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                  backgroundColor: "white",
                }}
                key={item.doc_ID}
              >
                <div className="order-main-list d-flex flex-column align-items-start px-2">
                  <h4 style={{ fontSize: "17px", color: "#6A6A6A" }}>
                  Rabies Serology form
                  </h4>
                  <h5 style={{ fontSize: "11px", color: "#6A6A6A" }}>
                    {formatDate(item.manual_createdDate)}
                  </h5>
                </div>
                <div style={{display: "flex",flexDirection: "column",alignItems: "flex-end"}}>                 

                  {item.is_submit === 2 ? (
                    <a
                      style={{
                        display: "flex",
                        color: "#00A3FF",
                        textDecoration: "none",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`${baseImageURL}Images/Documents/${item.relocation_id}/${item.doc_name}`}
                      download={`${item.doc_name}`}
                    >
                      Preview{" "}
                      <FontAwesomeIcon
                        icon={faArrowUpRightFromSquare}
                        style={{
                          padding: "5px 4px 0px 11px",
                          color: "#00A3FF",
                        }}
                      />
                    </a>
                  ) : null}
                  {item.is_submit === 2 ? (
                    <button
                      style={{
                        color: "#28A745",
                        fontWeight: "bold",
                        textDecoration: "none",
                        border: "none",
                        backgroundColor: "white",
                        display: "flex",
                      }}
                      onClick={() => submitDocument(item.doc_ID)}
                    >
                      Submit
                      <FontAwesomeIcon
                        icon={faArrowRightFromBracket}
                        style={{
                          padding: "5px 4px 0px 11px",
                          color: "#28A745",
                        }}
                      />
                    </button>
                  ) : (
                    <button
                      style={{
                        color: "#28A745",
                        width: "88%",
                        marginTop: "9.5px",
                        fontWeight: "bold",
                        cursor: "default",
                        textDecoration: "none",
                        border: "none",
                        backgroundColor: "white",
                      }}
                    >
                      Submitted
                    </button>
                  )}

                  {item.is_submit === 2 ? (
                    <button
                      onClick={() => deleteDoc(item.doc_ID)}
                      style={{
                        display: "flex",
                        color: "#FF0004",
                        borderStyle: "none",
                        background: "none",
                      }}
                    >
                      Delete{" "}
                      <DeleteOutlinedIcon
                        className="icon"
                        style={{ padding: "0 0 0 4px" }}
                      />
                    </button>
                  ) : null}
                </div>
              </div>
            ))}
          </>
        ) : null}
          </div>
          
        </div>
        <div
          className="py-4 px-2 mt-4"
          style={{ backgroundColor: "rgb(250, 250, 250)", borderRadius: "8px" }}
        >
          <h4 style={{ fontSize: "14px" }}>
          4. Upload the Titer Test report.
          </h4>
          <h6
            className="px-3 py-0"
            style={{ fontSize: "12.5px", color: "#A0A0A0" }}
          >
           A rabies titer test confirms the success of a rabies vaccine & checks
           the number of antibodies in your pet's blood.{" "}
            <span style={{ color: "#0096EB" }}>More Info</span>
          </h6>
          <h4
            className="px-3 py-0"
            style={{ fontSize: "12.5px", marginTop: "23px" }}
          >
            Date of blood sample collection.
          </h4>

          <div className="row px-3">
            <form className="form-row col-12 p-0 execution-step-2-form">
              <input
                style={{
                  border: "1px solid #BEBEBE",
                  borderTopLeftRadius: "8px",
                  borderBottomLeftRadius: "8px",
                  fontSize: "14px",
                  height: "38px",
                }}
                type="date"
                placeholder="Enter"
                className="form-input"
                name="dateValue4"
                  value={dateValue4}
                  onChange={handleChange}
              />
              <button
                style={{
                  border: "1px solid #5B489D",
                  height: "36px",
                  fontSize: "14px",
                  backgroundColor: "#F8F9FACC",
                  color: "#6a6a6a",
                  with: "114px",
                  padding: "4px 27px 4px 27px",
                  borderTopRightRadius: "8px",
                  borderBottomRightRadius: "8px",
                }}
                type="submit"
                className="form-button update-btn-new"
              >
                Update
              </button>
            </form>
            <form className="form-row col-12 px-0 py-3 execution-step-2-form">
              <input
                style={{
                  border: "1px solid #BEBEBE",
                  borderTopLeftRadius: "8px",
                  borderBottomLeftRadius: "8px",
                  fontSize: "14px",
                  height: "38px",
                }}
                type="file"
                placeholder="Enter"
                className="form-input"
                name="doc_name"
                  onChange={handleChangeDoc}
                  ref={fileInputRef}
                  required
              />
              <button
                style={{
                  border: "1px solid #5B489D",
                  height: "36px",
                  fontSize: "14px",
                  backgroundColor: "#F8F9FACC",
                  color: "#6a6a6a",
                  with: "114px",
                  padding: "4px 27px 4px 27px",
                  borderTopRightRadius: "8px",
                  borderBottomRightRadius: "8px",
                }}
                type="submit"
                className="form-button update-btn-new"
                onClick={(e) => {
                    e.preventDefault(); // Explicitly prevent default form submission
                    uploadVaccinationBook(4); // Call the function with your desired parameter
                  }}
              >
                Upload
              </button>
            </form>
            {individualDocResponse4?.length > 0 ? (
          <>
            <div className="px-3">
              <hr />
            </div>
            {individualDocResponse4.map((item, index) => (
              <div
                className="container-fluid mt-1 d-flex justify-content-between align-items-center py-2"
                style={{
                  borderRadius: "7px",
                  boxShadow:
                    "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                  backgroundColor: "white",
                }}
                key={item.doc_ID}
              >
                <div className="order-main-list d-flex flex-column align-items-start px-2">
                  <h4 style={{ fontSize: "17px", color: "#6A6A6A" }}>
                  Titre Test Report
                  </h4>
                  <h5 style={{ fontSize: "11px", color: "#6A6A6A" }}>
                    {formatDate(item.manual_createdDate)}
                  </h5>
                </div>
                <div style={{display: "flex",flexDirection: "column",alignItems: "flex-end"}}>                 

                  {item.is_submit === 2 ? (
                    <a
                      style={{
                        display: "flex",
                        color: "#00A3FF",
                        textDecoration: "none",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`${baseImageURL}Images/Documents/${item.relocation_id}/${item.doc_name}`}
                      download={`${item.doc_name}`}
                    >
                      Preview{" "}
                      <FontAwesomeIcon
                        icon={faArrowUpRightFromSquare}
                        style={{
                          padding: "5px 4px 0px 11px",
                          color: "#00A3FF",
                        }}
                      />
                    </a>
                  ) : null}
                  {item.is_submit === 2 ? (
                    <button
                      style={{
                        color: "#28A745",
                        fontWeight: "bold",
                        textDecoration: "none",
                        border: "none",
                        backgroundColor: "white",
                        display: "flex",
                      }}
                      onClick={() => submitDocument(item.doc_ID)}
                    >
                      Submit
                      <FontAwesomeIcon
                        icon={faArrowRightFromBracket}
                        style={{
                          padding: "5px 4px 0px 11px",
                          color: "#28A745",
                        }}
                      />
                    </button>
                  ) : (
                    <button
                      style={{
                        color: "#28A745",
                        width: "88%",
                        marginTop: "9.5px",
                        fontWeight: "bold",
                        cursor: "default",
                        textDecoration: "none",
                        border: "none",
                        backgroundColor: "white",
                      }}
                    >
                      Submitted
                    </button>
                  )}

                  {item.is_submit === 2 ? (
                    <button
                      onClick={() => deleteDoc(item.doc_ID)}
                      style={{
                        display: "flex",
                        color: "#FF0004",
                        borderStyle: "none",
                        background: "none",
                      }}
                    >
                      Delete{" "}
                      <DeleteOutlinedIcon
                        className="icon"
                        style={{ padding: "0 0 0 4px" }}
                      />
                    </button>
                  ) : null}
                </div>
              </div>
            ))}
          </>
        ) : null}
          </div>
         
        </div>        
      </>
    </div>
  );
}

export default ExecutionAndDocumentationMobileStep2;
